import {Controller} from "stimulus"

export default class extends Controller {
  static targets = [
    'container',
  ]

  connect() {
  }

  disconnect() {
  }

  copy(event) {
    event.preventDefault()
    this.containerTarget.select()
    document.execCommand("copy")
  }
}
